// extracted by mini-css-extract-plugin
export default {"tabs":"bjW98VyrRRW1R0rAkgna","tab":"hwwBBn2Ga9n57R77cf91","active":"DsyzBoeTIRtLjnZM7O0d","inactive":"ivIgpmsPNKwitCIjBlMq"};